export const formatDuration = (seconds: number): string => {
  // if (seconds === 0) return '0s';

  const hrs = Math?.floor(seconds / 3600);
  const mins = Math?.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const parts: string[] = [];
  if (hrs > 0) parts?.push(`${hrs}hr`);
  if (mins > 0) parts?.push(`${mins}m`);
  if (secs > 0 || parts?.length === 0) parts?.push(`${secs}s`);

  return parts?.join(' ');
};
